class BoxService {
  constructor({ axios }) {
    this.axios = axios;
    this.url = '/api/biobank/boxes';
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get(this.url, {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`${this.url}/${id}`);
    return data;
  }

  async create({ box }) {
    const { data } = await this.axios.post(this.url, box);
    return data;
  }

  async update({ box }) {
    const { data } = await this.axios.put(this.url, box);
    return data;
  }

  async archive({ box }) {
    const { _id: id } = box;
    const { data } = await this.axios.delete(`${this.url}/archive/${id}`, { data: box });
    return data;
  }
}

export default BoxService;
